import type { ReactNode } from 'react';

/**
 * Ênfase **dentro** de uma frase do catálogo: `*trecho*` vira `<strong>`.
 *
 * # POR QUE NÃO TRÊS CHAVES
 *
 * A alternativa óbvia — `…before` / `…strong` / `…after` — congela a ordem das
 * palavras do idioma base. «o ALLOW vale *ignorando os limites*» e «the ALLOW
 * holds *ignoring the limits*» põem a ênfase em posições diferentes, e um
 * tradutor que recebe três fragmentos não vê a frase que está traduzindo. Uma
 * chave = uma frase inteira, e o marcador viaja junto com a tradução.
 *
 * # POR QUE ISTO EXISTE COMO ARQUIVO
 *
 * Nasceu local ao Simulador (T18), de propósito: mecanismo compartilhado desta
 * frente já nasceu duplicado uma vez — o `plural.ts`, que a `i18n-telas` já
 * tinha como `tn()`. Virou arquivo quando apareceu o **segundo** consumidor (o
 * hub de Controle de acesso, cuja faixa tem duas ênfases numa frase só):
 * duplicar seis linhas para não decidir seria pior que decidir.
 *
 * Arquivo NOVO em vez de uma função no `i18n/index.ts` porque o `index.ts` é
 * compartilhado com a outra frente de extração e conflita a cada merge.
 *
 * # LIMITES, DITOS EM VOZ ALTA
 *
 * Não é markdown e não quer ser: só `*…*`, só `<strong>`, sem aninhamento e sem
 * escape. Um asterisco solto na frase fica literal (o `split` não casa par
 * ímpar), que é o comportamento seguro. Se algum dia uma tela precisar de link
 * ou de duas marcações diferentes, isto aqui **não** é o lugar de crescer — o
 * lugar é um renderizador de verdade.
 */
export function withEmphasis(texto: string): ReactNode[] {
  // `split` com grupo de captura intercala: [antes, capturado, depois, …] — os
  // índices ímpares são o que estava entre asteriscos.
  return texto
    .split(/\*([^*]+)\*/g)
    .map((parte, i) => (i % 2 === 1 ? <strong key={i}>{parte}</strong> : parte));
}
